<template>
  <div>
    <h1 class="text-left">{{ formTitle }}</h1>
    <hr>
    <b-form class="text-left" @submit.stop.prevent="handleSubmit">
      Board Name
      <b-form-input type="text"
                    required
                    placeholder="Enter Board Name"
                    v-model="board.name">
      </b-form-input>
      Description
      <b-form-textarea id="new-board"
                       required
                       placeholder="Enter a Description"
                       v-model="board.description"
                       :rows="3"
                       :max-rows="6">
      </b-form-textarea>

      <span v-if="!board.hasOwnProperty('id')" class="request-members">Add Members
        <MultiUserSelector v-on:user-change="setBoardUsers($event)" :parent="board" />
      </span>

      <span v-if="board.team">Team: {{ board.team.name }}</span>
      <b-form-select v-model="board.team_id" :options="teams"/>
      <b-form-group label="Privacy">
        <b-form-radio-group required stacked id="boardFormPrivacy" v-model="board.privacy_viewability" name="boardFormPrivacy">
          <b-form-radio value="all_users"><span class="oi oi-people"></span> Public</b-form-radio>
          <span class="radio-desc">
            Anyone can view this board
          </span>
          <b-form-radio value="board_members"><span class="oi oi-lock-locked"></span> Private to board members</b-form-radio>
          <span class="radio-desc">
            Only assigned members can view this board
          </span>
          <b-form-radio value="single_user"><span class="oi oi-person"></span> Private to me</b-form-radio>
          <span class="radio-desc">
            Only you can view this board
          </span>
        </b-form-radio-group>
      </b-form-group>
      <b-button class="submit-board-btn" type="submit">Submit</b-button>
      <b-button @click="resetBoard" variant="warning">Reset</b-button>
      <b-button v-if="board.hasOwnProperty('id')" @click="deleteBoard" variant="danger">Delete</b-button>

      <b-btn class="float-right" @click="hideModal">Close</b-btn>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MultiUserSelector from './selectors/users/MultiUserSelector.vue'
import SingleUserSelector from './selectors/users/SingleUserSelector.vue'
export default {
  name: 'boardForm',
  components: {
    MultiUserSelector,
    SingleUserSelector
  },
  props: {
    parentBoard: Object
  },
  data () {
    return {
      board: {
        name: '',
        team_id: null,
        description: '',
        privacy_viewability: '',
        user_ids: [],
        owner_id: null
      },
      formType: 'newBoard',
      formTitle: 'New Board',
      teams: [
        { value: null, text: 'Select a team' }
      ]
    }
  },
  created () {
    this.initForm()
    this.getTeams()
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },
  methods: {
    hideModal () {
      this.$root.$emit('bv::hide::modal', this.formType)
    },
    handleSubmit () {
      var boardObject
      if (this.board.hasOwnProperty('id')) {
        boardObject = this.mapBoardFields(this.board)
        this.submitEdit(boardObject)
      } else {
        boardObject = this.board
        this.submitNew(boardObject)
      }
    },
    submitNew (boardObject) {
      this.$http.post('/boards', { board: boardObject })
        .then(response => this.submitSuccessful(response))
        .catch(e => { console.log(e.response) })
    },
    submitEdit (boardObject) {
      var vm = this
      this.$http.put('/boards/' + boardObject.id, { board: boardObject })
        .then(function (response) {
          vm.submitSuccessful(response)
          vm.$root.$emit('boardWasUpdated', {})
        })
        .catch(e => { console.log(e.response) })
    },
    submitSuccessful (response) {
      this.hideModal()
      this.resetBoard()
    },
    deleteBoard () {
      var result = confirm('Are you sure?')
      if (result === true) {
        var vm = this
        this.$http.delete('/boards/' + this.board.id)
          .then(function (response) {
            vm.$router.push('/boards')
          })
          .catch(e => { console.log(e.response) })
      }
    },
    getTeams () {
      this.$http.get('/teams')
        .then(response => this.setTeams(response))
        .catch(e => { console.log(e.response) })
    },
    setTeams (response) {
      var vm = this
      response.data.forEach(function (team) {
        vm.teams.push({ text: team.name, value: team.id })
      })
    },
    setBoardUsers (user) {
      if (this.board.user_ids.includes(user.id)) {
        this.board.user_ids = this.board.user_ids.filter(function (id) {
          return id !== user.id
        })
      } else {
        this.board.user_ids.push(user.id)
      }
    },
    initForm () {
      if (this.parentBoard) {
        this.setEditFields()
      } else {
        this.setOwnerId()
      }
    },
    setOwnerId () {
      if (this.board.owner_id === null) {
        this.board.owner_id = this.currentUser.id
      }
    },
    setEditFields () {
      this.board = this.parentBoard
      this.formType = 'editBoard'
      this.formTitle = 'Edit Board'
    },
    mapBoardFields (board) {
      return {
        description: board.description,
        id: board.id,
        name: board.name,
        privacy_viewability: board.privacy_viewability,
        team_id: board.team_id,
        owner_id: board.owner.id
      }
    },
    resetBoard () {
      if (this.parentBoard) {
        this.$root.$emit('resetBoard')
      } else {
        this.board = {
          name: '',
          team_id: null,
          description: '',
          privacy_viewability: '',
          user_ids: [],
          owner_id: null
        }
      }
    }
  },
  watch: {
    parentBoard: function () {
      this.initForm()
    }
  }
}
</script>

<style>
#boardForm h1 {
  color: #6c757d;
  font-weight: bold;
}
#boardForm li {
  display: inline-block;
  margin-right: 20px;
}
#boardForm li a {
  color: #6c757d;
  text-decoration: none;
}
#boardForm li a:hover {
  border-bottom: 3px solid #57B2CD;
  margin-top: -4px;
}
#boardForm ul {
  padding-left: 10px;
}
#boardForm .form-control {
  margin-bottom: 20px;
}
#boardForm .radio-desc {
  margin-left: 30px;
  opacity: .5;
}
.submit-board-btn {
  background-color: #57B2CD;
  border-color: #57B2CD;
}
.submit-board-btn:hover {
  background-color: #3D92AB;
}
.modal-content {
  max-width: 600px;
  margin: 0 auto;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/BoardForm.vue